<template>
    <el-pagination
        class="responsive_pagination no-trans"
        v-bind="$attrs"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        :layout="compact ? 'prev,slot,next' : layout"
        :pager-count="mobile_view ? 5 : pagerCount"
        v-on="$listeners">
        <span v-if="compact" class="mobile_page_status" aria-live="polite">{{ currentPage }} / {{ Math.max(1, Math.ceil(total / pageSize)) }}</span>
        <slot v-else></slot>
    </el-pagination>
</template>
<script>
import mobile from '@/utils/mobile'

export default {
    inheritAttrs: false,
    props: {
        currentPage: { type: Number, default: 1 },
        pageSize: { type: Number, default: 10 },
        total: { type: Number, default: 0 },
        layout: { type: String, default: 'prev,pager,next' },
        pagerCount: { type: Number, default: 7 },
    },
    computed: {
        compact() { return mobile.compact },
    },
}
</script>
<style scoped lang="less">
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .responsive_pagination.no-trans {
        .mobile_page_status { min-width: 72px; height: 44px; padding: 0 12px; font-size: 14px; line-height: 44px; color: #526074; text-align: center; }
    }
}
</style>
